import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

import { ReactComponent as ParcelBox } from "assets/images/icons/ParcelBox.svg";
import CardItem from "./CardItem";

interface IProviderCardProps {
  isOffPlatformShipment?: boolean;
  offPlatformProvider: any;
  providersList: any[];
  providers: any[];
  displayLimit: number;
}

function ProviderCard({
  isOffPlatformShipment,
  offPlatformProvider,
  providersList,
  providers,
  displayLimit,
}: IProviderCardProps) {
  const [imageLoadErrors, setImageLoadErrors] = useState<Set<string | number>>(new Set());

  return (
    <CardItem>
      <p className="font-b3 text-secondary mb-2">
        <FormattedMessage id="general.provider" defaultMessage="Provider" />
      </p>
      {!isOffPlatformShipment ? (
        <p className="d-flex">
          {providersList?.length > 0
            ? providersList.map((provider: any) => (
                <OverlayTrigger
                  placement="bottom"
                  key={provider.id}
                  overlay={
                    <Tooltip id="freight-mode" style={{ zIndex: 999999 }}>
                      <span className="font-weight-normal">{provider.company_name || provider.label}</span>
                    </Tooltip>
                  }
                >
                  <div className="ml-1">
                    {!imageLoadErrors.has(provider.id) ? (
                      <img
                        src={provider.company_logo}
                        alt="provider-logo"
                        className="ml-2 rounded"
                        onError={() => setImageLoadErrors((prev) => new Set(prev).add(provider.id))}
                        height={24}
                      />
                    ) : (
                      <ParcelBox className="cursor-pointer" width={24} height={24} />
                    )}
                  </div>
                </OverlayTrigger>
              ))
            : "-"}
          {providersList?.length > 0 && providers?.length && providers?.length - displayLimit > 0 && (
            <OverlayTrigger
              placement="bottom"
              overlay={
                <Tooltip id="providers" style={{ zIndex: 999999 }}>
                  {providers.slice(displayLimit).map((provider: any) => (
                    <p key={provider.id} className="font-b3">
                      {provider.company_name || provider.label}
                    </p>
                  ))}
                </Tooltip>
              }
            >
              <button type="button" className="paginate-btn ml-1">
                {`+ ${providers?.length - displayLimit}`}
              </button>
            </OverlayTrigger>
          )}
        </p>
      ) : (
        <>{offPlatformProvider?.label}</>
      )}
    </CardItem>
  );
}

export default ProviderCard;
